module.exports = __webpack_public_path__ + "img/W3.33020bb1.png";